import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { QuoteIcon } from 'lucide-react';
export function PressQuoteSection() {
  return <section className="bg-cream text-charcoal py-24 px-6 md:px-12" data-id="element-141">
      <div className="max-w-5xl mx-auto text-center" data-id="element-142">
        <ScrollReveal data-id="element-143">
          <span className="block text-charcoal text-xs font-bold tracking-widest uppercase mb-10 opacity-50" data-id="element-144">
            Awards & Media
          </span>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-145">
          <QuoteIcon className="w-10 h-10 text-gold mx-auto mb-8 opacity-50" data-id="element-146" />
        </ScrollReveal>

        <ScrollReveal delay={0.3} data-id="element-147">
          <blockquote className="text-2xl md:text-4xl font-serif italic leading-relaxed text-charcoal mb-10" data-id="element-148">
            "The first Shiraz we tasted was on the day we arrived: Glenlofty's
            2023 from the rugged Pyrenees subregion with its cold winters and
            cool nights. It was the first time I'd encountered Shiraz like this.
            Like nothing from anywhere else."
          </blockquote>
        </ScrollReveal>

        <ScrollReveal delay={0.5} data-id="element-149">
          <cite className="block text-gold text-lg font-light not-italic tracking-wide" data-id="element-150">
            — Tamlyn Currin, JancisRobinson.com
          </cite>
        </ScrollReveal>
      </div>
    </section>;
}